<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('zhuima.taskUser.facebookNum')" prop="facebookNum">
                <a-input v-model="queryParam.facebookNum" :placeholder="$t('zhuima.taskUser.inputFacebookNum')" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item :label="$t('zhuima.taskUser.isFackbook')" prop="isFackbook">
                <a-input v-model="queryParam.isFackbook" :placeholder="$t('zhuima.taskUser.inputIsFackbook')" allow-clear/>
              </a-form-item>
            </a-col>
            <template v-if="advanced">
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.youtubeNum')" prop="youtubeNum">
                  <a-input v-model="queryParam.youtubeNum" :placeholder="$t('zhuima.taskUser.inputYoutubeNum')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.isYoutube')" prop="isYoutube">
                  <a-input v-model="queryParam.isYoutube" :placeholder="$t('zhuima.taskUser.inputIsYoutube')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.tiktok')" prop="tiktok">
                  <a-input v-model="queryParam.tiktok" :placeholder="$t('zhuima.taskUser.inputTiktok')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.isTiktok')" prop="isTiktok">
                  <a-input v-model="queryParam.isTiktok" :placeholder="$t('zhuima.taskUser.inputIsTiktok')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.openMessage')" prop="openMessage">
                  <a-input v-model="queryParam.openMessage" :placeholder="$t('zhuima.taskUser.inputOpenMessage')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.isOpen')" prop="isOpen">
                  <a-input v-model="queryParam.isOpen" :placeholder="$t('zhuima.taskUser.inputIsOpen')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.likeNum')" prop="likeNum">
                  <a-input v-model="queryParam.likeNum" :placeholder="$t('zhuima.taskUser.inputLikeNum')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="5" :sm="24">
                <a-form-item :label="$t('zhuima.taskUser.isLike')" prop="isLike">
                  <a-input v-model="queryParam.isLike" :placeholder="$t('zhuima.taskUser.inputIsLike')" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{ $t('common.query') }}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{ $t('common.reset') }}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('common.collapse') : $t('common.expand') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['taskUser:taskUser:add']">
          <a-icon type="plus" />{{ $t('common.add') }}
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['taskUser:taskUser:edit']">
          <a-icon type="edit" />{{ $t('common.edit') }}
        </a-button>
        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['taskUser:taskUser:remove']">
          <a-icon type="delete" />{{ $t('common.delete') }}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['taskUser:taskUser:export']">
          <a-icon type="download" />{{ $t('common.export') }}
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['taskUser:taskUser:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['taskUser:taskUser:edit']">
            <a-icon type="edit" />{{ $t('common.edit') }}
          </a>
          <a-divider type="vertical" v-hasPermi="['taskUser:taskUser:remove']" />
          <a @click="handleDelete(record)" v-hasPermi="['taskUser:taskUser:remove']">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageTaskUser,listTaskUser, delTaskUser } from '@/api/taskUser/taskUser'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'TaskUser',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        facebookNum: null,
        isFackbook: null,
        youtubeNum: null,
        isYoutube: null,
        tiktok: null,
        isTiktok: null,
        openMessage: null,
        isOpen: null,
        likeNum: null,
        isLike: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.facebookNum'),
          dataIndex: 'facebookNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.isFackbook'),
          dataIndex: 'isFackbook',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.youtubeNum'),
          dataIndex: 'youtubeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.isYoutube'),
          dataIndex: 'isYoutube',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.tiktok'),
          dataIndex: 'tiktok',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.isTiktok'),
          dataIndex: 'isTiktok',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.openMessage'),
          dataIndex: 'openMessage',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.isOpen'),
          dataIndex: 'isOpen',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.likeNum'),
          dataIndex: 'likeNum',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('zhuima.taskUser.isLike'),
          dataIndex: 'isLike',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('system.remark'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  watch: {
  },
  methods: {
    /** 查询任务奖励用户记录列表 */
    getList () {
      this.loading = true
     pageTaskUser(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        facebookNum: undefined,
        isFackbook: undefined,
        youtubeNum: undefined,
        isYoutube: undefined,
        tiktok: undefined,
        isTiktok: undefined,
        openMessage: undefined,
        isOpen: undefined,
        likeNum: undefined,
        isLike: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('system.confirmDelete'),
        content: this.$t('system.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delTaskUser(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('system.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('system.confirmExport'),
        content: this.$t('system.confirmExportContent'),
        onOk () {
          that.download('taskUser/task-user/export', {
            ...that.queryParam
          }, `${that.$t('zhuima.taskUser.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
